class $db53e2e9e82aca84$export$7fc53215244aec38 {
    constructor(caption, className){
        this.container = document.querySelector("#media-board");
        this.element = document.createElement("div");
        this.caption = caption;
        this.className = className;
        this.element.classList.add(className);
    }
    addToBoard() {
        this.container.appendChild(this.element);
        this.makeDraggable();
    }
    addImage(imageFile) {
        const img = document.createElement("img");
        img.src = URL.createObjectURL(imageFile);
        img.alt = this.caption;
        img.style.display = "block";
        this.element.appendChild(img);
        return img;
    }
    addCaption() {
        const caption = document.createElement("p");
        caption.classList.add('caption');
        caption.textContent = this.caption;
        this.element.appendChild(caption);
    }
    createContent() {
        this.addCaption();
        this.addToBoard();
    }
    makeDraggable() {
        Draggable.create(this.element, {
            type: "x,y",
            inertia: true,
            bounds: window,
            onDragStart: ()=>{
                this.element.classList.add("dragging");
            },
            onDragEnd: ()=>{
                this.element.classList.remove("dragging");
            }
        });
        window.addEventListener("resize", ()=>{
            Draggable.get(this.element).applyBounds();
        });
    }
}


class $11a4cafd46ec090f$export$b3c726fd70019c38 extends (0, $db53e2e9e82aca84$export$7fc53215244aec38) {
    constructor(imageFile, caption, date, className){
        super(caption, className);
        this.imageFile = imageFile;
        this.element.classList.add('photo-card');
        this.date = date;
    }
    createContent() {
        this.addImage(this.imageFile);
        this.addPhotoPlaque();
        super.addToBoard();
    }
    addPhotoPlaque() {
        const photoPlaque = document.createElement('div');
        photoPlaque.classList.add('photo-plaque');
        const caption = document.createElement("p");
        caption.classList.add('caption');
        caption.textContent = this.caption;
        photoPlaque.appendChild(caption);
        const date = document.createElement("p");
        date.classList.add('date');
        date.textContent = this.formatDate();
        photoPlaque.appendChild(date);
        this.element.appendChild(photoPlaque);
    }
    formatDate() {
        return new Date(this.date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            timeZone: 'UTC'
        });
    }
}



class $4283028485ec8ec7$export$de29f4c8c8ecaa89 extends (0, $db53e2e9e82aca84$export$7fc53215244aec38) {
    constructor(imageFile, caption, filter, className){
        super(caption, className);
        this.imageFile = imageFile;
        this.filter = filter;
    }
    createContent() {
        const img = this.addImage(this.imageFile);
        img.classList.add(this.filter);
        super.createContent();
    }
}



class $b8f03b7c772b0058$export$9ca6b0202bfc2895 extends (0, $db53e2e9e82aca84$export$7fc53215244aec38) {
    constructor(caption, colour, className){
        super(caption, className);
        this.colour = colour;
    }
    createContent() {
        this.element.style.backgroundColor = this.colour;
        super.createContent();
    }
}



class $fb9cf7aa6960fbfc$export$ea98c603db73aee7 extends (0, $db53e2e9e82aca84$export$7fc53215244aec38) {
    constructor(emoji, className){
        super('', className);
        this.emoji = emoji;
    }
    createContent() {
        this.element.textContent = this.emoji;
        this.addToBoard();
    }
    makeDraggable() {
        Draggable.create(this.element, {
            type: "x,y",
            inertia: true,
            bounds: window,
            onDragStart: ()=>{
                this.element.classList.add("dragging");
                this.element.style.zIndex = '2000';
            },
            onDragEnd: ()=>{
                this.element.classList.remove("dragging");
            }
        });
        window.addEventListener("resize", ()=>{
            Draggable.get(this.element).applyBounds();
        });
    }
}


function $7843fedae8aeb62a$export$b069765523c8278a() {
    const modalCon = document.querySelector('#modal-con');
    gsap.fromTo(modalCon, {
        scale: 0.8,
        opacity: 1
    }, {
        scale: 1,
        opacity: 1,
        duration: 0.2,
        ease: "elastic.out(1,0.5)"
    });
}
function $7843fedae8aeb62a$export$a28927ddae7ae0e4() {
    const modalCon = document.querySelector('#modal-con');
    gsap.to(modalCon, {
        scale: 0.8,
        opacity: 0,
        duration: 0.1,
        ease: "power2.out",
        onComplete: ()=>{
            modal.style.display = 'none';
        }
    });
}


function $fa97a21307504cd5$export$3f6fecd573f3fa48() {
    const modalCon = document.querySelector('#modal-con');
    const mediaTypeBtns = document.querySelectorAll('.media-type-btn');
    const mediaForms = document.querySelectorAll('.media-form, #sticker-form');
    mediaForms.forEach((form)=>{
        form.style.display = 'none';
        form.classList.remove('active');
    });
    modalCon.classList.remove('active');
    mediaTypeBtns.forEach((btn)=>btn.classList.remove('active'));
    (0, $7843fedae8aeb62a$export$a28927ddae7ae0e4)();
}


function $4d9b1f5cc62b1e30$export$71730bae229ad1d() {
    //VARIABLES
    const photoForm = document.querySelector('#photo-form');
    const polaroidForm = document.querySelector('#polaroid-form');
    const noteForm = document.querySelector('#note-form');
    const stickerForm = document.querySelector('#sticker-form');
    //FUNCTIONS
    function photoSubmit(e) {
        e.preventDefault();
        const imageInput = photoForm.querySelector(".image-input");
        const captionInput = photoForm.querySelector(".caption-input");
        const dateInput = photoForm.querySelector("#photo-date");
        const photo = new (0, $11a4cafd46ec090f$export$b3c726fd70019c38)(imageInput.files[0], captionInput.value, dateInput.value, 'photo-card');
        photo.createContent();
        (0, $fa97a21307504cd5$export$3f6fecd573f3fa48)();
        photoForm.reset();
    }
    function polaroidSubmit(e) {
        e.preventDefault();
        const imageInput = polaroidForm.querySelector(".image-input");
        const captionInput = polaroidForm.querySelector(".caption-input");
        const filterSelect = polaroidForm.querySelector("#filter");
        const polaroid = new (0, $4283028485ec8ec7$export$de29f4c8c8ecaa89)(imageInput.files[0], captionInput.value, filterSelect.value, 'polaroid-card');
        polaroid.createContent();
        (0, $fa97a21307504cd5$export$3f6fecd573f3fa48)();
        polaroidForm.reset();
    }
    function noteSubmit(e) {
        e.preventDefault();
        const captionInput = noteForm.querySelector(".caption-input");
        const colourSelect = noteForm.querySelector("#note-colour");
        const stickyNote = new (0, $b8f03b7c772b0058$export$9ca6b0202bfc2895)(captionInput.value, colourSelect.value, 'sticky-note');
        stickyNote.createContent();
        (0, $fa97a21307504cd5$export$3f6fecd573f3fa48)();
        noteForm.reset();
    }
    function stickerSubmit(e) {
        const emoji = e.target.dataset.emoji;
        const sticker = new (0, $fb9cf7aa6960fbfc$export$ea98c603db73aee7)(emoji, 'sticker');
        sticker.createContent();
        (0, $fa97a21307504cd5$export$3f6fecd573f3fa48)();
    }
    //EVENT LISTENERS
    photoForm.addEventListener('submit', photoSubmit);
    polaroidForm.addEventListener('submit', polaroidSubmit);
    noteForm.addEventListener('submit', noteSubmit);
    stickerForm.addEventListener('click', stickerSubmit);
}




function $c2201d90958a9027$export$df4163917f106d41() {
    //VARIABLES
    const modal = document.querySelector('#modal');
    const mediaBoard = document.querySelector("#media-board");
    const mediaForms = document.querySelectorAll('.media-form, #sticker-form');
    const addMediaBtn = document.querySelector('#add-media-btn');
    const resetMediaBtn = document.querySelector('#reset-media-btn');
    const mediaTypeBtns = document.querySelectorAll('.media-type-btn');
    const closeBtn = document.querySelector('#close-modal');
    const controls = document.querySelector('#controls-con');
    //FUNCTIONS
    function openModal() {
        hideAllForms();
        modal.style.display = 'block';
        (0, $7843fedae8aeb62a$export$b069765523c8278a)();
    }
    function outsideModal(e) {
        if (e.target === modal) (0, $fa97a21307504cd5$export$3f6fecd573f3fa48)();
    }
    function resetBoard() {
        mediaBoard.innerHTML = '';
    }
    function hideAllForms() {
        mediaForms.forEach((form)=>{
            form.style.display = 'none';
            form.classList.remove('active');
        });
    }
    function showSelectedForm(type) {
        hideAllForms();
        const selectedForm = document.querySelector(`#${type}-form`);
        selectedForm.style.display = 'flex';
        selectedForm.classList.add('active');
    }
    function selectMediaType(e) {
        const clickedBtn = e.currentTarget;
        const mediaType = clickedBtn.dataset.type;
        mediaTypeBtns.forEach((btn)=>{
            btn.classList.remove('active');
        });
        clickedBtn.classList.add('active');
        showSelectedForm(mediaType);
    }
    Draggable.create(controls, {
        type: "x,y",
        inertia: true,
        bounds: window,
        onDragStart: ()=>{
            controls.classList.add("dragging");
        },
        onDragEnd: ()=>{
            controls.classList.remove("dragging");
        }
    });
    window.addEventListener("resize", ()=>{
        Draggable.get(controls).applyBounds();
    });
    //EVENT LISTENERS
    addMediaBtn.addEventListener('click', openModal);
    resetMediaBtn.addEventListener('click', resetBoard);
    closeBtn.addEventListener('click', (0, $fa97a21307504cd5$export$3f6fecd573f3fa48));
    modal.addEventListener('click', outsideModal);
    mediaTypeBtns.forEach((btn)=>{
        btn.addEventListener('click', selectMediaType);
    });
}


(0, $4d9b1f5cc62b1e30$export$71730bae229ad1d)();
(0, $c2201d90958a9027$export$df4163917f106d41)();


//# sourceMappingURL=index.5398a4d6.js.map
